import React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";

interface Props {
  isSelected?: boolean;
  onClick?: any;
}
const CategoryButton: React.FC<Props> = ({ children, isSelected, onClick }) => {
  return (
    <StyledButtonWrapper onClick={onClick} isSelected={isSelected}>
      {children}
    </StyledButtonWrapper>
  );
};

export default CategoryButton;

const StyledButtonWrapper = styled.div<Props>`
  border-bottom: ${({ isSelected }) =>
    isSelected ? `2px solid ${theme.colors.gray1}` : `2px solid transparent`};
  margin: 0 16px 1px 16px;
  height: 65px;

  color: ${({ isSelected }) =>
    isSelected ? theme.colors.gray1 : theme.colors.gray6};
  cursor: pointer;
  ${theme.typo.heading.b18};
  line-height: 65px;
`;
